module.exports = __webpack_public_path__ + "../../img/logo_ff_small.mondrian.svg";